/**
 * TODO: describe function
 * @author Kevin Parkinson
 * @param classOfTrades (EntryCollection<ContentfulClassOfTrade>)
*/
export const simplifyContentfulClassOfTrades = (classOfTrades: any[]): string[] => classOfTrades.map((item) => (item && item.fields && item.fields.classOfTrade ? item.fields.classOfTrade : ''));
